import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { CashCollectionPage } from '@/features/marketPromotion/pages/CashCollectionPage';
import { approvalReportSearchSchema } from '@/features/marketPromotion/types/marketPromotionP2.types';

export const Route = createFileRoute('/_auth/market-promotion/cash-collection')({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.CASH_COLLECTION_VIEW),
  validateSearch: approvalReportSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Cash Collection">
      <Suspense fallback={<PageLoader />}>
        <CashCollectionPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
